import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import globalMessages from 'messages';
import { Icon } from 'components';
import useTopMobileTitle from './useTopMobileTitle';
import fireGlyph from 'assets/svg/fire.svg';
import './topMobileTitle.scss';

interface Props {}

const TopMobileTitle: React.FC<Props> = () => {
    const {
        route,
        isMobileTopMatchesVisible,
        isMobileTopMatchesOpened,
        handleOpenMobileTopMatches,
    } = useTopMobileTitle();

    if (!isMobileTopMatchesVisible) return null;

    return (
        <div styleName="container">
            <Link to={route} styleName="button">
                <div onClick={handleOpenMobileTopMatches} styleName="wrapper">
                    <Icon glyph={fireGlyph} />

                    <span
                        styleName={cn('title', {
                            active: isMobileTopMatchesOpened,
                        })}
                    >
                        <FormattedMessage {...globalMessages.top} />
                    </span>
                </div>
            </Link>
        </div>
    );
};

export default React.memo(TopMobileTitle);
